<template>
    <div>
        <button class="btnV" @click="ExportToExcel('xlsx')">
            <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" class="ml-2" style="position: inherit;top:3px" />
            <span class="ml-2">Exportar</span>
        </button>
        <table class="styled-table" >
            <thead>
                <tr>
                    <th>#</th>
                    <th>Estudiante</th>
                    <th>Intentos</th>
                    <th id="showColumnTarea">Calificación</th>
                    <th>Rúbrica</th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,key) in arregloEstudiantes" :key="key">
                    <td>{{ key + 1  }}</td>
                    <td>{{ item.estudiante }}</td>
                    <td ><p v-if="item.evaluacion.length > 0">{{ item.intentos.length }}</p></td>
                    <td ><p v-if="item.evaluacion.length > 0">{{ item.evaluacion[0].calificacion }}</p></td>
                    <td ><p v-if="item.evaluacion.length > 0">{{ item.evaluacion[0].rubrica_calificacion }}</p></td>
                    <td class="showColumnTarea2">
                        <div v-if="item.evaluacion.length > 0" class="flex" style="flex-wrap: wrap;">
                            <button class="btnV m-2" @click="ObjectEvaluacion=item;mostrarIntentos();">
                                <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="ml-2" style="position: inherit;top:3px" />
                                <span class="ml-2">Ver</span>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <!--IMPRIMIR-->
        <!-- <table class="styled-table" id="tbl_exporttable_to_xls" style="display: none;">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Estudiante</th>
                    <th>Fecha de entrega</th>
                    <th>Calificación</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,key) in arregloEstudiantes" :key="key">
                    <td>{{ key + 1  }}</td>
                    <td>{{ item.estudiante }}</td>
                    <td>
                        <div v-if="item.tarea.length > 0">
                            {{ item.tarea[0].created_at }}
                        </div>
                        <div v-else>
                            <span>Tarea aun no subida</span>
                        </div>
                    </td>
                    <td>
                        <div v-if="item.tarea.length > 0">
                            <span>{{ item.tarea[0].calificacion }}</span>
                        </div>
                        <div v-else>
                            <span>0</span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table> -->
        <!--MODALES-->
        <vs-popup classContent="popup-example" fullscreen title="Mostrar evaluación" @close="limpiar();" :active.sync="popupMostrarEvaluacion">
            <div v-if="popupMostrarEvaluacion">
                <vs-tabs alignment="fixed">
                    <vs-tab label="Desafío" @click="tipoM = 0;">
                        <div>
                
                        </div>
                    </vs-tab>
                    <vs-tab label="Rúbrica" @click="mostrarRubrica();">
                        <div>
                
                        </div>
                    </vs-tab>
                </vs-tabs>
                <!---evaluacion-->
                <div v-if="tipoM == 0">
                    <small>Seleccione el intento:</small>
                    <div class="flex">
                        <v-select @input="mostrarEvaluacionIntento();" :options="arrayIntentos" :reduce="arrayIntentos => arrayIntentos" label="intento" class="w-full" v-model="intentoSelected" />
                        <!--button buscar-->
                        <vs-button @click="mostrarEvaluacionIntento()" icon="search" class="ml-2" type="gradient" color="success">Buscar</vs-button>
                    </div>
                    <div v-if="arrayPreguntas.length > 0">
                        <EvaluacionRevisarVue @changeHandle="changeHandle" :setEvaluacion="ObjectSelected" :ObjectEvaluacion="ObjectEvaluacion" :arrayPreguntas="arrayPreguntas"  :intentoSelected="intentoSelected"/>
                    </div>
                </div>
                <!--rubrica-->
                <div v-if="tipoM == 1">
                    <RubricaRevisarVue :ObjectEvaluacion="ObjectEvaluacion" :arrayPreguntasRubrica="arrayPreguntasRubrica"/>
                </div>
                <br><br><br><br><br>
            </div>
        </vs-popup>
    </div>
</template>
<script>
// import DetalleTareasEnviadasVue from './DetalleTareasEnviadas.vue';
const RubricaRevisarVue     = () => import('./RubricaRevisar.vue');
const EvaluacionRevisarVue  = () => import('./EvaluacionRevisar.vue');
import vSelect from 'vue-select'
import GeneralMixin from "@/mixins/GeneralMixin.js";
export default{
    mixins: [GeneralMixin],
    components:{
        RubricaRevisarVue,
        'v-select': vSelect,
        EvaluacionRevisarVue,
    },
    data(){
        return{
            idPreguntaAbierta:7,
            arrayPreguntasRubrica:[],
            popupMostrarEvaluacion:false,
            ObjectEvaluacion:'',
            arrayIntentos:[],
            intentoSelected:'',
            arrayPreguntas:[],
            tipoM:0,
        }
    },
    props:{
        ObjectSelected:{
            type:Object,
            default:function(){
                return {}
            }
        },
        userDocente:{
            type:Boolean,
            default:false,
        },
        arregloEstudiantes:{
            type:Array,
            default:function(){
                return []
            }
        }
    },
    watch:{
        arregloEstudiantes:{
            handler(newValue,oldValue){
                let me = this
                me.arregloEstudiantes   = newValue
            },
            deep:true
        }
    },
    mounted() {
        let me = this;
    },
    methods: {
        limpiar(){
            this.arrayPreguntas         = []
            this.arrayPreguntasRubrica  = []
            this.intentoSelected        = ''
            this.tipoM                  = 0
        },
        changeHandle(){
            let me = this
            me.popupMostrarEvaluacion = false
            me.limpiar()
            me.$emit('changeHandle',true)
        },
        mostrarRubrica(){
            let me = this
            me.$vs.loading()
            this.$http.get(this.$server_url+`evaluacionRubrica?getRubricaEvaluacion=1&idEvaluacion=${me.ObjectSelected.id}&id_estudiante=${me.ObjectEvaluacion.usuario_idusuario}`)
            .then(res => {
                me.$vs.loading.close()
                if(res.data.status == 0){
                    me.f_notificaciones(res.data.message, "danger");
                    return
                }
                me.arrayPreguntasRubrica = res.data
                me.tipoM = 1;
            })
            .catch(err => {
                me.$vs.loading.close()
                me.f_notificaciones("Error al realizar la rúbrica", "danger");
            })
        },
        mostrarIntentos(){
            let me = this
            me.arrayIntentos = []
            me.arrayIntentos = me.ObjectEvaluacion.intentos
            if(me.arrayIntentos.length > 0){
                me.arrayIntentos.forEach((i,index) => {
                    i.intento = "Intento "+(index + 1)
                })
            }
            me.intentoSelected = me.arrayIntentos[0]
            //ejecutar
            me.mostrarEvaluacionIntento()
            me.popupMostrarEvaluacion = true;
        },
        mostrarEvaluacionIntento(){
            let me = this
            if(me.intentoSelected == '' || me.intentoSelected == null || me.intentoSelected == undefined) return me.f_notificaciones("Seleccione un intento", "warning");
            me.arrayPreguntas = []
            let formData = new FormData();
            formData.append('id_evaluacion_estudiante',this.intentoSelected.id_evaluacion_estudiante);
            formData.append('traerEvaluacionIntento','1')
            me.$vs.loading()
            this.$http.post(this.$server_url+'evaluacionEstudiante', formData)
            .then(res => {
                me.$vs.loading.close()
                if(res.data.status == 0){
                    this.$vs.notify({
                        title: 'Error',
                        text: res.data.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }
                me.arrayPreguntas = res.data
                //excluir las preguntas abiertas con id 7
                me.arrayPreguntas = me.arrayPreguntas.filter((i) => i.id_tipo != me.idPreguntaAbierta)
                //juntar al ultimo las preguntas abiertas 
                me.arrayPreguntas = [...me.arrayPreguntas,...res.data.filter((i) => i.id_tipo == me.idPreguntaAbierta)]
                //si es de id_tipo == 5 en la propiedad respuestas se guarda un json porque son preguntas de tipo columna
                me.arrayPreguntas.forEach((i,index) => {
                    if(i.id_tipo == 5 || i.id_tipo == 8){
                        if(i.respuestas.length > 0){
                            //si la respuesta[0].respuesta es nulo o vacio no aplico el JSON.parse
                            if(i.respuestas[0].respuesta != null && i.respuestas[0].respuesta != ''){
                                i.respuestas[0].respuesta = JSON.parse(i.respuestas[0].respuesta)
                                //si es pregunta de tipo 8 que es pregunta de seleccion multiple
                                if(i.id_tipo == 8){
                                    i.respuestas[0].respuesta.forEach((j) => {
                                        if(j.seleccionar == "true"){
                                            j.seleccionar = true
                                        }else if(j.seleccionar == "false"){
                                            j.seleccionar = false
                                        }
                                    })
                                }
                            }else{
                                //si la respuesta[0].respuesta es nulo o vacio no aplico el JSON.parse y coloco array vacio
                                i.respuestas[0].respuesta = []
                            }
                        }
                    }
                })
            })
            .catch(err => {
                me.$vs.loading.close()
                me.f_notificaciones("Error al traer la evaluación "+err, "danger");
            })
        },
        //metodo par descargar el excel
        ExportToExcel(type, fn, dl) {
            let me  = this
            var elt = document.getElementById('tbl_exporttable_to_xls');
            var wb  = XLSX.utils.table_to_book(elt, { sheet: "sheet1" });
            return dl ?
                XLSX.write(wb, { bookType: type, bookSST: true, type: 'base64' }):
                XLSX.writeFile(wb, fn || ('ReporteCalificaciones.' + (type || 'xlsx')));
        },
    },
}
</script>
<style lang="scss">
@import '@/assets/scss/general/general.scss';
.styled-table {
  border-collapse: collapse;
  margin: 25px 0;
  font-size: 0.9em;
  font-family: sans-serif;
  min-width: 100%;

}
.styled-table thead tr {
  background-color: #EBF3F8;
  color: #22262D;
  text-align: left;
}
.styled-table th,
.styled-table td {
    padding: 12px 15px;
}
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}

.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}

.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid #009879;
}
.styled-table tbody tr.active-row {
  font-weight: bold;
  color: #009879;
}
/*ESTILOS BOTONES*/
.btnV{
    color:#3E4448;
    background-color:#EBF3F8;
    border: none;
    padding: 5px 10px;
    border-radius: 5px;
    font-weight: 100;
    font-size: 11px;
    transition: 0.5s ease;
    cursor: pointer;
}
.btnV:hover{
    color: #3EA0EA;
}
.btnV2{
    color:#3E4448;
    background-color:#eae7e6;
    border: none;
    padding: 5px 10px;
    border-radius: 5px;
    font-weight: 100;
    font-size: 11px;
    transition: 0.5s ease;
    cursor: pointer;
}
.btnV2:hover{
    color: #3EA0EA;
}
.title-informacion{
    background-color: var(--fondo);
    padding: 10px;
    color:var(--titulo)
}
</style>